import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { WebSocketSubject } from 'rxjs/webSocket'

import { Character, Room } from '@mmocld/data'
import { Message, RoomJoinedMessage, RoomMessage } from '@mmocld/message'

import { RoomService } from '../model/room.service'

@Component({
  selector: 'app-room-select',
  templateUrl: './room-select.component.html',
  styleUrls: ['./room-select.component.scss'],
})
export class RoomSelectComponent implements OnInit {
  @Input() connectedCharacter?: Character
  @Input() joinedRoom?: Room
  @Input() ws!: WebSocketSubject<Message>
  @Output() setRoom = new EventEmitter<Room>()

  rooms: Room[] = []

  constructor(private roomService: RoomService) {}

  ngOnInit(): void {
    this.ws.subscribe({
      next: (message) => {
        this.recieveMessage(message)
      },
    })
    this.loadRoomOwn()
    this.loadRooms()
  }

  recieveMessage(message: Message) {
    if (!message.type?.startsWith('Room')) return

    const roomMessage = <RoomMessage>message

    switch (roomMessage.type) {
      case 'RoomJoinedMessage':
        const roomJoinedMessage = <RoomJoinedMessage>message
        this.setRoom.emit(<Room>{ roomId: roomJoinedMessage.body.roomId })
        break
      case 'RoomLeftMessage':
        this.setRoom.emit()
        break
      case 'RoomCharacterJoinedMessage':
        break
      case 'RoomCharacterLeftMessage':
        break
    }
    this.loadRooms()
  }

  loadRoomOwn() {
    if (this.connectedCharacter) {
      this.roomService.getOwn(this.connectedCharacter).subscribe((room) => {
        if (room) this.setRoom.emit(room)
      })
    }
  }
  loadRooms() {
    this.roomService.getAll().subscribe((rooms) => {
      this.rooms = rooms
    })
  }
  join(room: Room) {
    this.roomService.join(this.ws, { roomId: room.roomId })
  }
  leave() {
    this.roomService.leave(this.ws)
  }
}
